import request from '@/utils/http'

const PREFIX = '/meta_event'
// 元事件
const metaEvent = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  },

  list(params) {
    return request(
      `${PREFIX}/list`,
      'get',
      params
    )
  }
}

export default metaEvent
